import { Box, Container, Typography } from "@mui/material";

import { Acronym, CTDNA, DNA, RNA } from "components/acronyms";
import { Subtitle1Text } from "components/shared/Typography";

export const TopBanner = () => (
  <Box
    component="section"
    height={250}
    position="relative"
    className="default-bg"
    overflow="hidden"
  >
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        pt={{ xs: "46px", sm: "39px", md: "32px", lg: "45px" }}
        gap={{ xs: "18px", sm: "24px", md: "30px" }}
        position="relative"
      >
        <Typography variant="h1" align="center">
          <Box
            fontSize={{ xs: 22, sm: 64 }}
            lineHeight={{ xs: "28px", sm: "80px" }}
            letterSpacing={{ xs: 0.25, sm: 0 }}
          >
            Custom Panels
          </Box>
        </Typography>
        <Subtitle1Text align="center">
          Design custom next-generation sequencing (<Acronym text="NGS" />)
          panels for <RNA />, <DNA /> or <CTDNA /> input. It’s your panel, your
          way.
        </Subtitle1Text>
      </Box>
    </Container>
  </Box>
);
